var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-item",attrs:{"href":_vm.to},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon,"alt":_vm.title}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }